import React, { ComponentRef, forwardRef, useCallback } from 'react'

import { E164Number } from 'libphonenumber-js/core'
import phone from 'phone'
import PhoneNumberInput, { Props, DefaultInputComponentProps } from 'react-phone-number-input'

type Ref = ComponentRef<typeof PhoneNumberInput>
const PhoneInput = forwardRef<Ref, Props<DefaultInputComponentProps>>(({ onChange, ...props }, ref) => {
  const handleChange = useCallback(
    (value: E164Number) => {
      const { phoneNumber } = phone(value)
      onChange((phoneNumber as E164Number) || value)
    },
    [onChange],
  )

  return <PhoneNumberInput ref={ref} onChange={handleChange} {...props} />
})

PhoneInput.displayName = 'PhoneInput'

export default PhoneInput
